import { Injectable } from '@angular/core';
import { ApplicationModel } from '@ups/xplat/api/dto';
import { ProspectService } from './prospect.service';

@Injectable({
  providedIn: 'root',
})
export class TradeClassesResolver {
  constructor(
    private prospectService: ProspectService,
    private applicationModel: ApplicationModel
  ) {}

  public load(): Promise<unknown> {
    if (this.applicationModel.tradeClasses.length === 0) {
      return this.prospectService
        .getTradeClasses()
        .then(
          (data: typeof this.applicationModel.tradeClasses) =>
            (this.applicationModel.tradeClasses = data)
        );
    }

    return Promise.resolve(this.applicationModel.tradeClasses);
  }
}
